import React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex justify-center items-center shadow-inner flat:!shadow-none rounded-xl w-max font-body font-normal whitespace-nowrap",
  {
    variants: {
      variant: {
        info: "shadow-info-200 bg-blue-100 text-blue-500",
        secondary: "shadow-[#5D5FEF] border border-[#5D5FEF] !text-[#5D5FEF] bg-transparent",
        purple: "bg-[#6938EF26] text-[#6938EF]",
        success: "bg-success-100 text-success-700 shadow-success-200",
        warning: "bg-warning-100 text-warning-600 shadow-warning-200 ",
        error: "bg-error-100 text-error-600 shadow-error-200",
        subtle: "bg-gray-100 text-gray-600 shadow-gray-200",
      },
      size: {
        sm: "gap-1 px-2 py-0.5 text-sm",
        md: "text-md gap-1.5 px-2.5 py-1",
        lg: "gap-2 px-3 py-1.5 text-lg",
      },
    },

    defaultVariants: {
      variant: "info",
      size: "md",
    },
  }
)

export interface BadgeProps
  extends React.ComponentProps<"div">,
    VariantProps<typeof badgeVariants> {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  iconClassName?: string
}
export const Badge = ({
  children,
  variant,
  className,
  leftIcon,
  rightIcon,
  size,
  iconClassName,
}: BadgeProps) => {
  return (
    <div className={badgeVariants({ variant, className, size })}>
      {leftIcon && (
        <div className={cn("flex scale-90 items-center justify-center", iconClassName)}>
          {leftIcon}
        </div>
      )}
      <div>{children}</div>
      {rightIcon && (
        <div className={cn("flex scale-90 items-center justify-center", iconClassName)}>
          {rightIcon}
        </div>
      )}
    </div>
  )
}
